import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    title: {
      type: String,
      default: "Imagem de capa",
    },
    proportion: {
      type: String | null,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["imageFileUrl"]),
  },
  watch: {
    imageFileUrl: {
      handler(newValue) {
        if (newValue) {
          this.convertToImageFile(newValue);
        }
      },
      // immediate: true
    },
  },
  methods: {
    ...mapActions(["setImageFileUrl"]),
    previewImage($event) {
      let input = $event.target;
      if (input.files?.[0]) {
        // create a new FileReader to read this image and convert to base64 format
        let reader = new FileReader();

        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Read image as base64 and set url in setImageFileUrl
          let result = e.target.result.replace(
            /^data:image\/(png|jpg|jpeg|webp);base64,/,
            ""
          );
          this.setImageFileUrl(result);
          console.log(this.imageFileUrl);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    convertToImageFile(url) {
      url = `data:image/jpg;base64,${url}`;

      // convert url image to blob
      fetch(url)
        .then((res) => res.blob())
        .then((data) => {
          console.log("DATA IMAGE", data);
          // set image in category picture
          this.$emit("changePicture", data);
        });
    },
    clearInputFile() {
      this.$refs.fileuploadimage.value = null;
      this.setImageFileUrl(null);
      this.$emit("changePicture", null);
    },
  },
};
